export const SET_QUEUES = "SET_QUEUES";
export const UPDATE_QUEUE = "UPDATE_QUEUE";
export const REMOVE_QUEUE = "REMOVE_QUEUE";
